class RouteStopApiResponseModel {
  // #region Props

  // #endregion
  constructor({
    category,
    id,
    name,
    province,
  },
  locale = 'es-ES',
  ) {
    return {
      category,
      id,
      name,
      province,
    };
  }
}

export default RouteStopApiResponseModel;
